module.exports = __webpack_public_path__ + "ionicons.05acfdb568b3df49ad31.woff";


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/assets/fonts/ionicons.woff?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons.woff?v=2.0.0
// module chunks = styles